export const content = {
  title: "Select a property",
  previousTitle: "Previous properties",
  allPropertiesLabel: "ALL ACTIVE PROPERTIES",
  hide: "Hide",
  show: "Show previous properties",
  moveIn: "Move in to a new property",
  disconnect: "Disconnect a property",
  multipleProperties:
    "Seeing multiple listings for the same address? Don't worry, we're working to fix it.",
};
